import React, { Component } from 'react';

class ForgotPassword extends Component {
  /**
   * Render the component view.
   */
  render() { 
    return (
      <div>
        <div className="modal__header">
          <h3 className="modal-title common-title">
            Forgot Password
          </h3>
        </div>

        <div className="modal__body">
          <div className="modal__body-content--pad35 text-center">
            <p className="modal-paragraph">
              Enter your email address or mobile number below and we´ll send you a link to reset your password.
            </p>

            {this.props.form}
          </div>
        </div>
      </div>
    );
  }
}
 
export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/components/application/modals/forgot-password.js